import React, { ComponentType } from 'react';
import { Trans } from 'react-i18next';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { LinkProps, Paragraph } from '../../styledComponents';

export type TrainerProps = {
  displayName: string;
  uri: string;
  prefix?: boolean;
  as: ComponentType<LinkProps>;
};

export function Trainer(props: TrainerProps) {
  const { uri, displayName, prefix, as: Component } = props;

  const { sitePath } = useRootSelector(selectPageConfig);

  const trainerLink = `${sitePath}/trainers/${uri}`;

  return prefix ? (
    <Paragraph>
      <Trans
        i18nKey="site.modules.course-option-display.trainer.prefix"
        values={{ 0: displayName }}
      >
        <Component to={trainerLink} label={displayName} />
      </Trans>
    </Paragraph>
  ) : (
    <Component to={trainerLink} label={displayName} />
  );
}
